import { render, staticRenderFns } from "./historyAi.vue?vue&type=template&id=0c791f10&scoped=true&"
import script from "./historyAi.vue?vue&type=script&lang=js&"
export * from "./historyAi.vue?vue&type=script&lang=js&"
import style0 from "./historyAi.vue?vue&type=style&index=0&id=0c791f10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c791f10",
  null
  
)

export default component.exports